/**
 * WhatsThisButton — iter84.68 · plain-speak explainers for check surfaces.
 *
 * A small "?" that opens a popover answering, in plain language:
 * what this card is, what good looks like, and what it is NOT for.
 * Requested by the operator so each Release Ops / Product Ops surface
 * is self-describing without reading docs.
 */
import { HelpCircle } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

function Section({ label, children, cls = "text-zinc-300" }) {
    if (!children) return null;
    return (
        <div>
            <div className="text-[9px] font-bold uppercase tracking-widest text-zinc-500 mb-0.5">{label}</div>
            <p className={`text-[11px] leading-snug ${cls}`}>{children}</p>
        </div>
    );
}

export function WhatsThisButton({ title, what, lookFor, notFor, testId }) {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <span
                    role="button"
                    tabIndex={0}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => e.stopPropagation()}
                    data-testid={testId}
                    className="brutal-btn-ghost text-[10px] py-1 px-1.5 inline-flex items-center cursor-pointer"
                    title={`What is "${title}"?`}
                >
                    <HelpCircle className="w-3.5 h-3.5" />
                </span>
            </PopoverTrigger>
            <PopoverContent
                className="w-80 bg-zinc-950 border-zinc-700 space-y-2.5 p-3"
                onClick={(e) => e.stopPropagation()}
                data-testid={testId ? `${testId}-content` : undefined}
            >
                <div className="text-xs font-bold uppercase tracking-wider text-cyber">{title}</div>
                <Section label="What this is">{what}</Section>
                <Section label="What good looks like" cls="text-emerald-200/90">{lookFor}</Section>
                <Section label="Not for" cls="text-zinc-400">{notFor}</Section>
            </PopoverContent>
        </Popover>
    );
}
